"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eachComponentAsync = void 0;
const index_1 = require("./index");
// Async each component.
function eachComponentAsync(components_1, fn_1) {
    return __awaiter(this, arguments, void 0, function* (components, fn, includeAll = false, path = '', parent) {
        var _a, _b;
        if (!components)
            return;
        for (let i = 0; i < components.length; i++) {
            if (!components[i]) {
                continue;
            }
            const component = components[i];
            const info = (0, index_1.componentInfo)(component);
            // Keep track of parent references.
            if (parent) {
                // Ensure we don't create infinite JSON structures.
                Object.defineProperty(component, 'parent', {
                    enumerable: false,
                    writable: true,
                    value: JSON.parse(JSON.stringify(parent)),
                });
                Object.defineProperty(component.parent, 'parent', {
                    enumerable: false,
                    writable: true,
                    value: parent.parent,
                });
                Object.defineProperty(component.parent, 'path', {
                    enumerable: false,
                    writable: true,
                    value: parent.path,
                });
                delete component.parent.components;
                delete component.parent.componentMap;
                delete component.parent.columns;
                delete component.parent.rows;
            }
            const compPath = (0, index_1.componentPath)(component, path);
            if (includeAll || component.tree || !info.layout) {
                if (yield fn(component, compPath, components, parent)) {
                    continue;
                }
            }
            if (info.hasColumns) {
                for (let j = 0; j < component.columns.length; j++) {
                    yield eachComponentAsync((_a = component.columns[j]) === null || _a === void 0 ? void 0 : _a.components, fn, includeAll, path, parent ? component : null);
                }
            }
            else if (info.hasRows) {
                for (let j = 0; j < component.rows.length; j++) {
                    const row = component.rows[j];
                    if (Array.isArray(row)) {
                        for (let k = 0; k < row.length; k++) {
                            yield eachComponentAsync((_b = row[k]) === null || _b === void 0 ? void 0 : _b.components, fn, includeAll, path, parent ? component : null);
                        }
                    }
                }
            }
            else if (info.hasComps) {
                yield eachComponentAsync(component.components, fn, includeAll, (0, index_1.componentFormPath)(component, path, compPath), parent ? component : null);
            }
        }
    });
}
exports.eachComponentAsync = eachComponentAsync;
